import api from '@/api/bmkg'
import xmlToJson from 'xml-to-json-stream'

const parser = xmlToJson({attributeMode:false})

const state = {
  sensedQuakes: [],
  recentQuakes: {}
}

const mutations = {
  setSensedQuakes (state, value) {
    state.sensedQuakes = value
  },
  setRecentQuakes (state, value) {
    state.recentQuakes = value
  }
}

const actions = {
  getSensedQuakes ({commit}) {
    return api.getSensedQuakes()
      .then(res => {
        const data = res.data
        parser.xmlToJson(data, (err, json) => {
          commit('setSensedQuakes', json.Infogempa.Gempa)
        })
      })
  },
  getRecentQuakes ({commit}) {
    return api.getRecentQuakes()
      .then(res => {
        const data = res.data
        parser.xmlToJson(data, (err, json) => {
          commit('setRecentQuakes', [json.Infogempa.gempa])
        })
      })
  }
}

const getters = {
  sensedQuakes: state => state.sensedQuakes || [],
  recentQuakes: state => state.recentQuakes || []
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
